import Vue from 'vue';
import Vuex from 'vuex';

import { layout } from './layout.module';
import { alert } from './alert.module';
import { account } from './account.module';
import { cart } from './cart.module';
import { item } from './item.module';
import { resource } from './resource.module';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    layout,
    resource,
    alert,
    account,
    cart,
    item,
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js